module.exports = __webpack_public_path__ + "videos/beginners-series_1x1.d7c2091.mp4";